// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__c2CI3","title":"Header_title__3eqVK","side":"Header_side__3gppo"};